/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Name of a group
 * @export
 * @interface GroupName
 */
export interface GroupName {
    /**
     * 
     * @type {string}
     * @memberof GroupName
     */
    uid?: string;
}

/**
 * Check if a given object implements the GroupName interface.
 */
export function instanceOfGroupName(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GroupNameFromJSON(json: any): GroupName {
    return GroupNameFromJSONTyped(json, false);
}

export function GroupNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uid': !exists(json, 'uid') ? undefined : json['uid'],
    };
}

export function GroupNameToJSON(value?: GroupName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uid': value.uid,
    };
}

